<div class="alert alert-info"
     role="alert">
    <p>Configure Lumia access via external accounts.</p>
    @if (articleUrl) {
        <a [href]="articleUrl"
           rel="noreferrer noopener"
           target="_blank">Find out more about single sign-on (SSO) in {{ projectLabel }}</a>
    }
</div>

@if (errorMessage) {
    <div class="alert alert-danger"
         role="alert">
        {{ errorMessage }}
    </div>
}

<div *adaptLoading="!configuredProviders"
     class="d-flex flex-column gap-3">
    @if (!canRemoveProvider) {
        <div class="alert alert-warning m-0">
            <p>You cannot remove your last remaining external account as your account does not have a password set.</p>
            <p>You can set a password for your account within the "Change Password" section above.</p>
        </div>
    }

    @if (configuredProviders!.length > 0) {
        <p>Your account is configured to allow logging in using the following external accounts:</p>
        <div class="d-flex flex-column gap-2">
            @for (provider of configuredProviders; track provider) {
                <ng-template #buttonTemplate
                             let-provider="provider">
                    <button type="button"
                            class="btn btn-danger"
                            [attr.data-test]="'remove-' + provider.provider.toLowerCase()"
                            [disabled]="!canRemoveProvider"
                            [adaptBlockingClick]="removeProvider"
                            [adaptBlockingClickParam]="provider"
                            [unsubscribeOnDestroy]="false">Remove access</button>
                </ng-template>

                <ng-container [ngTemplateOutlet]="providerTemplate"
                              [ngTemplateOutletContext]="{
                        provider: ExternalLoginProviders[provider.provider],
                        button: buttonTemplate,
                    }"></ng-container>
            }
        </div>
    } @else {
        <div>You have not configured any external accounts yet.</div>
    }

    @if (otherProviders!.length > 0) {
        <div>
            <p>You can log in using the following external accounts:</p>
            <div class="d-flex flex-column gap-2">
                @for (provider of otherProviders; track provider) {
                    <ng-template #buttonTemplate
                                 let-provider="provider">
                        <button type="button"
                                class="btn btn-primary"
                                [attr.data-test]="'sign-in-' + provider.provider.toLowerCase()"
                                [adaptBlockingClick]="signInProvider"
                                [adaptBlockingClickParam]="provider"
                                [unsubscribeOnDestroy]="false">Login using {{ provider.providerDisplayName }}</button>
                    </ng-template>

                    <ng-container [ngTemplateOutlet]="providerTemplate"
                                  [ngTemplateOutletContext]="{
                            provider: ExternalLoginProviders[provider.provider],
                            button: buttonTemplate,
                        }"></ng-container>
                }
            </div>
        </div>
    }
</div>

<ng-template #providerTemplate
             let-provider="provider"
             let-button="button">
    @if (provider) {
        <div class="row provider">
            <div class="col d-flex gap-2 align-items-center">
                <img [src]="provider.iconPath"
                     [alt]="provider.providerDisplayName"
                     style="height: 40px; width: 40px" />

                <h4 class="mb-0">{{ provider.providerDisplayName }}</h4>
            </div>
            <div class="col-auto">
                <ng-container [ngTemplateOutlet]="button"
                              [ngTemplateOutletContext]="{ provider }"></ng-container>
            </div>
        </div>
    }
</ng-template>
